import {
  useCallback,
  useMemo,
  useRef,
  useState,
  type ChangeEvent,
  type MouseEvent,
} from 'react';

import type { PaginationControls } from 'commons/modules/pagination';

export const PAGINATION_DEFAULT_PAGE_SIZE = 50;

export type UsePaginationOptions = {
  initialPageSize?: number;
};

const usePagination = (options?: UsePaginationOptions) => {
  const baselineRef = useRef<PaginationControls>({
    page: 0,
    pageSize: options?.initialPageSize ?? PAGINATION_DEFAULT_PAGE_SIZE,
  });

  const paginationDefault = useMemo<PaginationControls>(
    () => ({ ...baselineRef.current }),
    [],
  );

  const [pagination, setPagination] = useState<PaginationControls>(() => ({
    ...baselineRef.current,
  }));

  const resetPagination = useCallback(() => {
    setPagination({ ...baselineRef.current });
  }, []);

  const handleChangePage = useCallback(
    (_event: MouseEvent<HTMLButtonElement> | null, value: number) => {
      setPagination((prev) => ({ ...prev, page: value }));
    },
    [],
  );

  const handleChangeRowsPerPage = useCallback((event: ChangeEvent<any>) => {
    setPagination((prev) => ({
      ...prev,
      page: 0,
      pageSize: Number(event.target.value),
    }));
  }, []);

  return {
    pagination,
    setPagination,
    paginationDefault,
    resetPagination,
    handleChangePage,
    handleChangeRowsPerPage,
  };
};

export default usePagination;
